import { render, staticRenderFns } from "./OrderPerformanceTable.vue?vue&type=template&id=4a45fb38&scoped=true"
import script from "./OrderPerformanceTable.vue?vue&type=script&lang=js"
export * from "./OrderPerformanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45fb38",
  null
  
)

export default component.exports